// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___38gQF","First":"style__First___B2zsM","FirstInner":"style__FirstInner___1vevB","FirstInnerOverlay":"style__FirstInnerOverlay___3s9kB","FirstInnerOverlaySlogan":"style__FirstInnerOverlaySlogan___37cx2","FirstInnerOverlayTitle":"style__FirstInnerOverlayTitle___LbkfJ","FirstInnerOverlaySubtitle":"style__FirstInnerOverlaySubtitle___2htSQ"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/carousel/property/first/style.css
// module id = 1458
// module chunks = 0